export default ($axios) => ({
  fetch(query) {
    return $axios.get('/admin/sms/trackers', { params: query }).then((response) => response.data);
  },
  store(payload) {
    return $axios.post('/admin/sms/trackers', payload).then((response) => response.data);
  },
  destroy(id) {
    return $axios.delete(`/admin/sms/trackers/${id}`).then((response) => response.data);
  },
});
